import { useTranslation } from 'react-i18next'
import { CONTACT_EMAIL } from '../config.js'

export default function AboutPage() {
  const { t } = useTranslation()
  const inside = t('about.inside', { returnObjects: true })
  const faq = t('about.faq', { returnObjects: true })

  return (
    <main className="mx-auto flex max-w-[1080px] flex-col gap-14 px-4 pt-14 pb-[72px] sm:px-8">
      <section className="flex flex-wrap items-center gap-10">
        <div className="flex flex-[1_1_420px] flex-col gap-4">
          <span className="text-sm font-extrabold tracking-[2px] text-teal uppercase">{t('about.eyebrow')}</span>
          <h1 className="text-[clamp(34px,4.5vw,54px)] leading-[1.05] font-black tracking-[-1.4px] text-balance">
            {t('about.title')}
          </h1>
          <p className="text-lg leading-relaxed text-muted">{t('about.lead')}</p>
        </div>
        <div className="flex aspect-square flex-[0_1_300px] items-center justify-center rounded-full bg-mint">
          <img src="/brand/urbanpurr-mark.svg" alt="" className="h-auto w-[72%]" />
        </div>
      </section>

      <section className="flex flex-col gap-6">
        <h2 className="text-[32px] font-black tracking-[-0.8px]">{t('about.insideTitle')}</h2>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(min(220px,100%),1fr))] gap-4">
          {inside.map((item) => (
            <div key={item.t} className="flex flex-col gap-2 rounded-[20px] bg-sand p-[22px]">
              <span className="text-lg font-extrabold">{item.t}</span>
              <span className="text-[15px] leading-normal text-muted">{item.d}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="text-[32px] font-black tracking-[-0.8px]">{t('about.faqTitle')}</h2>
        <div className="flex flex-col border-t border-line">
          {faq.map((item, i) => (
            <details key={item.q} className="border-b border-line py-5" open={i === 0}>
              <summary className="cursor-pointer text-[19px] font-extrabold">{item.q}</summary>
              <p className="mt-3 text-base leading-relaxed text-muted">{item.a}</p>
            </details>
          ))}
        </div>
      </section>

      <section className="flex flex-wrap items-center justify-between gap-6 rounded-[28px] border border-line bg-panel p-[clamp(28px,5vw,48px)] text-on-panel">
        <div className="flex flex-col gap-2">
          <h2 className="text-3xl font-black">{t('about.partnersTitle')}</h2>
          <p className="text-[17px] text-on-dark-muted">{t('about.partnersText')}</p>
        </div>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="rounded-full bg-surface px-[26px] py-4 font-extrabold text-ink no-underline transition hover:bg-mint"
        >
          {CONTACT_EMAIL}
        </a>
      </section>
    </main>
  )
}
